import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import { useRef as F, useState as C, useEffect as R } from "react";
import { F as S } from "./flex-Cc3osQLf.mjs";
import { m as b } from "./tss-DN0acMKN.mjs";
import { M as E, d as V } from "./constants-CnFYFetN.mjs";
import { i as h, m as k, s as A } from "./index-DpjUVRH2.mjs";
import { T as i } from "./Typography-DfkimCSn.mjs";
function I(t, o, e) {
  e === void 0 && (e = {});
  var n = h(t) ? t : k(t);
  return A("", n, o, e), {
    stop: function() {
      return n.stop();
    }
  };
}
const O = b()(({ mode: t }) => ({
  text: {
    color: t === E.Dye ? V.main : void 0
  }
})), G = ({
  from: t = 0,
  to: o,
  prefix: e,
  suffix: n,
  TypographyProps: s = {},
  PrefixProps: x = {},
  SuffixProps: j = {},
  formatter: l = (a) => a,
  animateDuration: u = 1,
  ...p
}) => {
  const a = F(null), [d, M] = C(t), { classes: r, cx: c } = O();
  return R(() => {
    const f = a.current;
    if (f) {
      const N = I(d, o, {
        duration: u,
        onUpdate: (v) => f.textContent = l(v.toFixed(0)),
        onComplete: () => M(o)
      });
      return () => N.stop();
    }
  }, [d, o, u, l]), /* @__PURE__ */ m.jsxs(S, { alignItems: "baseline", "data-fabric-component": "MotionTypography", ...p, children: [
    e && /* @__PURE__ */ m.jsx(i, { ...s, ...x, className: c(r.text, s.className), children: e }),
    /* @__PURE__ */ m.jsx(i, { ...s, className: c(r.text, s.className), ref: a }),
    n && /* @__PURE__ */ m.jsx(i, { ...s, ...j, className: c(r.text, s.className), children: n })
  ] });
};
export {
  G as M,
  I as a
};
//# sourceMappingURL=motion-typography-EKAOBuk7.mjs.map
